const details = {
    name: "شرکت داده پردازان اتومبیل ایران",
    enName: "shop",
    description: "شرکت داده پردازان اتومبیل ایران",
    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    }
}

export default details;
